
(function () {
  function initDiamondPreview(root) {
    if (!root || root.dataset.dpInitialized === 'true') return;

    var blockId = root.getAttribute('data-dp-preview');
    var productScript = document.getElementById('dp-product-json-' + blockId);

    if (!productScript) return;

    root.dataset.dpInitialized = 'true';

    var product = JSON.parse(productScript.textContent);
  var DRILLS_PER_CM = 4;
  var SMALL_PAINTING_MAX_COLOURS = 45;
  var LARGE_PAINTING_MAX_COLOURS = 60;
  var MAX_PREVIEW_WIDTH = 900;
  var MAX_PREVIEW_HEIGHT = 1200;
  var SHAPE_ROUND = 'Round';
  var SHAPE_SQUARE = 'Square';
  var ENHANCEMENT_STANDARD = 'Standard';
  var ENHANCEMENT_AB = 'AB Diamonds';
  var ENHANCEMENT_PRIORITY = 'Priority Processing';
  var ENHANCEMENT_AB_PRIORITY = 'AB Diamonds + Priority Processing';
  var PHOTO_UPLOAD_ENDPOINT = 'https://diamond-upload.customer-service-3a8.workers.dev/';
  var ALLOWED_PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

  var state = {
    image: null,
    imageUrl: '',
    cartPreviewImageUrl: '',
    uploadedFileName: '',
    uploadedPhotoUrl: '',
    uploadedPhotoKey: '',
    uploadedPhotoName: '',
    isUploadingPhoto: false,
    photoUploadError: '',
    photoUploadRequestId: 0,
    customKitId: '',
    zoom: 1,
    panX: 0,
    panY: 0,
    rotation: 0,
    isEditing: false,
    hasChosenSize: false,
    userHasManuallySelectedSize: false,
    showAllSizes: false,
    isPanning: false,
    isAddingToCart: false,
    isCartEdit: false,
    isProgrammaticSizeChange: false,
    editCartItemKey: '',
    editOriginalPhotoUrl: '',
    editRestoreParams: null,
    dragStartX: 0,
    dragStartY: 0,
    dragStartPanX: 0,
    dragStartPanY: 0,
    selectedVariantId: null,
    lastVariantId: null,
    recommendedSizeKey: ''
  };

  var els = {
    upload: root.querySelector('[data-dp-upload]'),
    kitId: root.querySelector('[data-dp-kit-id]'),
    photoName: root.querySelector('[data-dp-photo-name]'),
    photoUrl: root.querySelector('[data-dp-photo-url]'),
    photoKey: root.querySelector('[data-dp-photo-key]'),
    abCheckbox: root.querySelector('[data-dp-addon-ab]'),
    abLabel: root.querySelector('[data-dp-ab-label]'),
    priorityCheckbox: root.querySelector('[data-dp-addon-priority]'),
    success: root.querySelector('[data-dp-success]'),
    panelEmpty: root.querySelector('[data-dp-panel-empty]'),
    sizeHelp: root.querySelector('[data-dp-size-help]'),
    suggestion: root.querySelector('[data-dp-suggestion]'),
    upgrade: root.querySelector('[data-dp-upgrade]'),
    controls: root.querySelector('[data-dp-controls]'),
    editToggle: root.querySelector('[data-dp-edit-toggle]'),
    changePhoto: root.querySelector('[data-dp-change-photo]'),
    removePhoto: root.querySelector('[data-dp-remove-photo]'),
    addToCart: root.querySelector('[data-dp-add-to-cart]'),
    primaryAction: root.querySelector('.dp-preview__primary-action'),
    continueNote: root.querySelector('[data-dp-continue-note]'),
    zoom: root.querySelector('[data-dp-zoom]'),
    panX: root.querySelector('[data-dp-pan-x]'),
    panY: root.querySelector('[data-dp-pan-y]'),
    rotateLeft: root.querySelector('[data-dp-rotate-left]'),
    rotateRight: root.querySelector('[data-dp-rotate-right]'),
    sizeOptions: root.querySelector('[data-dp-size-options]'),
    shapeOptions: root.querySelector('[data-dp-shape-options]'),
    canvasWrap: root.querySelector('[data-dp-canvas-wrap]'),
    empty: root.querySelector('[data-dp-empty]'),
    canvas: root.querySelector('[data-dp-canvas]')
  };

  function getProductForm() {
    return root.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
  }

  function getOrCreateFormId(form) {
    if (!form) return '';

    if (!form.id) {
      form.id = 'dp-product-form-' + blockId;
    }

    return form.id;
  }

  function ensurePhotoPropertiesAttachedToForm() {
    var form = getProductForm();
    var formId = getOrCreateFormId(form);

    if (!form || !formId) return;

    form.setAttribute('enctype', 'multipart/form-data');

    /*
      Shopify can store file line item properties when the original file input
      is submitted with the product form. The preview object URL is browser-only;
      if a theme cart script converts the form to plain JSON and drops files,
      this will need a persistent upload endpoint and a saved image URL property.
    */
    [els.photoUrl].forEach(function (input) {
      if (!input) return;
      input.setAttribute('form', formId);
    });
  }

  function createCustomKitId() {
    return 'KIT-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8).toUpperCase();
  }

  function updatePhotoLineItemProperties(file) {
    state.uploadedFileName = file ? file.name : '';
    state.uploadedPhotoName = state.uploadedFileName;

    if (els.photoName) els.photoName.value = state.uploadedFileName;

    ensurePhotoPropertiesAttachedToForm();

    /*
    console.log('[Diamond Preview] uploaded file/property attached', {
      uploadedFileName: state.uploadedFileName,
      customKitId: state.customKitId,
      fileInputName: els.upload ? els.upload.name : null,
      hasFile: !!(els.upload && els.upload.files && els.upload.files[0])
    });
    */
  }

  function ensureCustomKitId() {
    if (!state.customKitId) {
      state.customKitId = createCustomKitId();
    }

    if (els.kitId) els.kitId.value = state.customKitId;

    return state.customKitId;
  }

  function clearUploadedPhotoStorage() {
    state.uploadedPhotoUrl = '';
    state.uploadedPhotoKey = '';
    state.uploadedPhotoName = '';
    state.photoUploadError = '';

    if (els.photoUrl) els.photoUrl.value = '';
    if (els.photoKey) els.photoKey.value = '';
  }

  function setSuccessState(isVisible) {
    if (!els.success) return;

    els.success.hidden = !isVisible;
    els.success.style.display = isVisible ? 'grid' : 'none';
    if (els.primaryAction) els.primaryAction.hidden = !!isVisible;
    root.classList.toggle('has-success', !!isVisible);

    if (isVisible && typeof els.success.scrollIntoView === 'function') {
      window.setTimeout(function () {
        els.success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 80);
    }
  }

  function setUploadedPhotoStorage(data, file) {
    var photo = data.file || data.photo || data.upload || data.image || {};
    var uploadedPhotoUrl = data.uploadedPhotoUrl || data.url || data.publicUrl || data.imageUrl ||
      photo.uploadedPhotoUrl || photo.url || photo.publicUrl || photo.imageUrl || '';
    var uploadedPhotoKey = data.uploadedPhotoKey || data.key || data.objectKey || data.path ||
      photo.uploadedPhotoKey || photo.key || photo.objectKey || photo.path || '';
    var uploadedPhotoName = data.uploadedPhotoName || data.fileName || data.name ||
      photo.uploadedPhotoName || photo.fileName || photo.name || (file ? file.name : '');

    if (!uploadedPhotoUrl) {
      throw new Error('Upload completed but no uploaded photo URL was returned.');
    }

    state.uploadedPhotoUrl = uploadedPhotoUrl;
    state.uploadedPhotoKey = uploadedPhotoKey;
    state.uploadedPhotoName = uploadedPhotoName;
    state.uploadedFileName = uploadedPhotoName;
    state.photoUploadError = '';

    if (els.photoUrl) els.photoUrl.value = uploadedPhotoUrl;
    if (els.photoKey) els.photoKey.value = uploadedPhotoKey;
    if (els.photoName) els.photoName.value = uploadedPhotoName;
  }

  function getFriendlyUploadError(error) {
    var message = error && error.message ? error.message : '';

    if (/failed to fetch|networkerror|load failed/i.test(message)) {
      return 'Photo upload could not reach the upload server. This is usually a CORS or network issue. Please try again.';
    }

    return message || 'Photo upload failed. Please try again.';
  }

  function uploadPhotoToWorker(file) {
    var requestId = state.photoUploadRequestId + 1;
    var formData = new FormData();
    var customKitId = ensureCustomKitId();

    state.photoUploadRequestId = requestId;
    state.isUploadingPhoto = true;
    state.photoUploadError = '';
    clearUploadedPhotoStorage();
    updateSubmitState();

    formData.append('file', file);
    formData.append('customKitId', customKitId);

    console.log('[Diamond Preview] photo upload request', {
      endpoint: PHOTO_UPLOAD_ENDPOINT,
      method: 'POST',
      bodyType: 'FormData',
      hasFile: formData.has('file'),
      hasCustomKitId: formData.has('customKitId'),
      selectedFileName: file ? file.name : '',
      selectedFileType: file ? file.type : '',
      selectedFileSize: file ? file.size : 0,
      customKitId: customKitId,
      origin: window.location.origin
    });

    return fetch(PHOTO_UPLOAD_ENDPOINT, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Accept': 'application/json'
      },
      body: formData
    })
      .then(function (response) {
        return response.text().then(function (text) {
          var data = {};

          console.log('[Diamond Preview] photo upload response', {
            status: response.status,
            statusText: response.statusText,
            ok: response.ok,
            accessControlAllowOrigin: response.headers.get('Access-Control-Allow-Origin'),
            responseBody: text
          });

          if (text) {
            try {
              data = JSON.parse(text);
            } catch (error) {
              data = { message: text };
            }
          }

          if (!response.ok) {
            throw new Error(data.error || data.message || 'Photo upload failed.');
          }

          return data;
        });
      })
      .then(function (data) {
        if (requestId !== state.photoUploadRequestId) return;

        setUploadedPhotoStorage(data, file);
      })
      .catch(function (error) {
        if (requestId !== state.photoUploadRequestId) return;

        clearUploadedPhotoStorage();
        state.photoUploadError = getFriendlyUploadError(error);
        console.error('[Diamond Preview] Photo upload failed', {
          endpoint: PHOTO_UPLOAD_ENDPOINT,
          selectedFileName: file ? file.name : '',
          selectedFileType: file ? file.type : '',
          selectedFileSize: file ? file.size : 0,
          customKitId: customKitId,
          origin: window.location.origin,
          errorName: error && error.name ? error.name : '',
          errorMessage: error && error.message ? error.message : '',
          errorStack: error && error.stack ? error.stack : '',
          likelyCause: /failed to fetch|networkerror|load failed/i.test(error && error.message ? error.message : '')
            ? 'Browser blocked or could not reach the Worker. Check Worker CORS, OPTIONS preflight, endpoint availability, and HTTPS.'
            : ''
        });
      })
      .finally(function () {
        if (requestId !== state.photoUploadRequestId) return;

        state.isUploadingPhoto = false;
        updateSubmitState();
      });
  }

  function isAllowedPhotoFile(file) {
    var name = file && file.name ? file.name.toLowerCase() : '';
    var type = file && file.type ? file.type.toLowerCase() : '';

    return ALLOWED_PHOTO_TYPES.indexOf(type) !== -1 ||
      /\.(jpe?g|png|webp)$/i.test(name);
  }

  function syncPhotoPropertiesToFormData(formData) {
    if (!formData) return;

    formData.set('properties[Uploaded Photo URL]', state.uploadedPhotoUrl || '');
    formData.delete('properties[Custom Kit ID]');
    formData.delete('properties[Uploaded Photo Name]');
    formData.delete('properties[Uploaded Photo Key]');
    formData.delete('properties[AB Diamonds]');
    formData.delete('properties[Priority Processing]');
    formData.delete('properties[Enhancement]');

    /*
    console.log('[Diamond Preview] final cart item properties submitted', {
      uploadedFileName: state.uploadedFileName,
      customKitId: state.customKitId,
      finalProperties: {
        'Uploaded Photo URL': state.uploadedPhotoUrl || ''
      }
    });
    */
  }

  function normalizeText(value) {
    return String(value || '')
      .replace(/&times;/gi, 'x')
      .replace(/[\u00d7\u2715]/g, 'x')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeComparable(value) {
    return normalizeText(value)
      .replace(/\s*x\s*/gi, 'x')
      .replace(/\s*\+\s*/g, '+')
      .toLowerCase();
  }

  function getVariantDebugRows() {
    return (product.variants || []).map(function (variant) {
      var size = getSizeFromVariant(variant);

      return {
        id: variant.id,
        title: variant.title,
        available: variant.available,
        price: variant.price,
        options: getVariantOptions(variant),
        diamondType: getShapeFromVariant(variant),
        size: size ? size.label : null,
        sizeKey: getSizeKey(size),
        enhancement: getEnhancementFromVariant(variant)
      };
    });
  }

  function getSelectedOptions(form) {
    if (!form) return [];

    var selected = [];

    form.querySelectorAll('select').forEach(function (select) {
      if (select.name !== 'id' && select.value) selected.push(normalizeText(select.value));
    });

    form.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach(function (input) {
      if (input.name !== 'id' && input.value) selected.push(normalizeText(input.value));
    });

    return selected;
  }

  function getSelectedVariant() {
    if (state.selectedVariantId) {
      var selectedByUploader = product.variants.find(function (variant) {
        return String(variant.id) === String(state.selectedVariantId);
      });

      if (selectedByUploader) return selectedByUploader;
    }

    var form = getProductForm();
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var selectedId = idInput ? String(idInput.value || '') : '';
    var urlVariantId = new URLSearchParams(window.location.search).get('variant');

    if (selectedId) {
      var byId = product.variants.find(function (variant) {
        return String(variant.id) === selectedId;
      });

      if (byId) return byId;
    }

    if (urlVariantId) {
      var byUrlId = product.variants.find(function (variant) {
        return String(variant.id) === String(urlVariantId);
      });

      if (byUrlId) return byUrlId;
    }

    var selectedOptions = getSelectedOptions(form);
    var byOptions = product.variants.find(function (variant) {
      return getVariantOptions(variant).every(function (option) {
        return selectedOptions.indexOf(normalizeText(option)) !== -1;
      });
    });

    return byOptions || product.selected_or_first_available_variant || product.variants[0] || null;
  }

  function getVariantOptions(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options;

    return [variant.option1, variant.option2, variant.option3].filter(function (option) {
      return option !== null && option !== undefined && option !== '';
    });
  }

  function getSizeFromText(text) {
    var match = normalizeText(text).match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*cm/i);
    if (!match) return null;

    return {
      label: Number(match[1]) + 'x' + Number(match[2]) + 'cm',
      a: Number(match[1]),
      b: Number(match[2])
    };
  }

  function getSizeFromVariant(variant) {
    if (!variant) return null;

    var options = getVariantOptions(variant);

    for (var i = 0; i < options.length; i += 1) {
      var size = getSizeFromText(options[i]);
      if (size) return size;
    }

    var titleSize = getSizeFromText(variant.title);
    return titleSize || null;
  }

  function getShapeFromVariant(variant) {
    if (!variant) return SHAPE_ROUND;

    var options = getVariantOptions(variant);
    var joined = normalizeText(options.join(' ') + ' ' + (variant.title || ''));

    if (options[0]) {
      if (/\bsquare\b/i.test(options[0])) return SHAPE_SQUARE;
      if (/\bround\b/i.test(options[0])) return SHAPE_ROUND;
    }

    if (/\bsquare\b/i.test(joined)) return SHAPE_SQUARE;
    if (/\bround\b/i.test(joined)) return SHAPE_ROUND;

    return SHAPE_ROUND;
  }

  function getSelectedEnhancement() {
    var hasAbDiamonds = isAddOnSelected('ab');
    var hasPriorityProcessing = isAddOnSelected('priority');

    if (hasAbDiamonds && hasPriorityProcessing) return ENHANCEMENT_AB_PRIORITY;
    if (hasAbDiamonds) return ENHANCEMENT_AB;
    if (hasPriorityProcessing) return ENHANCEMENT_PRIORITY;

    return ENHANCEMENT_STANDARD;
  }

  function getEnhancementFromVariant(variant) {
    var options = getVariantOptions(variant);
    var enhancement = normalizeText(options[2] || '');

    if (!enhancement) {
      var title = normalizeText(variant && variant.title ? variant.title : '');

      if (/ab diamonds\s*\+\s*priority processing/i.test(title)) return ENHANCEMENT_AB_PRIORITY;
      if (/ab diamonds/i.test(title)) return ENHANCEMENT_AB;
      if (/priority processing/i.test(title)) return ENHANCEMENT_PRIORITY;
    }

    if (/^ab diamonds\s*\+\s*priority processing$/i.test(enhancement)) return ENHANCEMENT_AB_PRIORITY;
    if (/^ab diamonds$/i.test(enhancement)) return ENHANCEMENT_AB;
    if (/^priority processing$/i.test(enhancement)) return ENHANCEMENT_PRIORITY;

    return ENHANCEMENT_STANDARD;
  }

  function getMatchedSelectedVariant() {
    var currentVariant = getSelectedVariant();
    var sizeKey = getSizeKey(getSizeFromVariant(currentVariant));
    var shape = getShapeFromVariant(currentVariant);
    var enhancement = getSelectedEnhancement();

    if (!sizeKey || !shape) {
      console.warn('[Diamond Preview] cannot match variant because size or diamond type is missing', {
        currentVariant: currentVariant,
        selectedDiamondType: shape,
        selectedSize: sizeKey,
        selectedEnhancement: enhancement,
        allVariants: getVariantDebugRows()
      });
      return null;
    }

    return findVariantForSelection(sizeKey, shape, enhancement);
  }

  function getAvailableSizes() {
    var seen = {};
    var sizes = [];

    (product.variants || []).forEach(function (variant) {
      var size = getSizeFromVariant(variant);
      if (!size) return;

      var small = Math.min(size.a, size.b);
      var large = Math.max(size.a, size.b);
      var key = small + 'x' + large;

      if (!seen[key]) {
        seen[key] = true;
        sizes.push(size);
      }
    });

    return sizes;
  }

  function getAvailableShapes() {
    var seen = {};
    var shapes = [];

    (product.variants || []).forEach(function (variant) {
      var shape = getShapeFromVariant(variant);
      if (seen[shape]) return;

      seen[shape] = true;
      shapes.push(shape);
    });

    return shapes.length ? shapes : [SHAPE_ROUND, SHAPE_SQUARE];
  }

  function getSizeKey(size) {
    if (!size) return '';
    return Math.min(size.a, size.b) + 'x' + Math.max(size.a, size.b);
  }

  function sizeKeysMatch(a, b) {
    return normalizeComparable(a) === normalizeComparable(b);
  }

  function shapesMatch(a, b) {
    return normalizeComparable(a) === normalizeComparable(b);
  }

  function enhancementsMatch(a, b) {
    return normalizeComparable(a) === normalizeComparable(b);
  }

  function getSizeRatioKey(size) {
    if (!size) return '';

    var small = Math.min(size.a, size.b);
    var large = Math.max(size.a, size.b);

    return String(Math.round((small / large) * 1000));
  }

  function getSizeArea(size) {
    if (!size) return 0;
    return size.a * size.b;
  }

  function isVariantAvailable(variant) {
    return !!variant && variant.available !== false;
  }

  function getSelectedQuantity() {
    var form = getProductForm();
    var quantityInput = form ? form.querySelector('[name="quantity"]') : null;
    var quantity = quantityInput ? Number(quantityInput.value) : 1;

    return Math.max(1, Math.floor(quantity || 1));
  }

  function getCheckboxLabelText(input) {
    var parts = [];
    var id = input && input.id;
    var wrappingLabel = input ? input.closest('label') : null;
    var matchingLabel = id
      ? document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(id) : id.replace(/"/g, '\\"')) + '"]')
      : null;

    if (wrappingLabel) parts.push(wrappingLabel.textContent || '');
    if (matchingLabel) parts.push(matchingLabel.textContent || '');
    if (input) {
      parts.push(input.name || '');
      parts.push(input.id || '');
      parts.push(input.value || '');
      Array.prototype.slice.call(input.attributes || []).forEach(function (attribute) {
        if (/^data-/i.test(attribute.name)) parts.push(attribute.value || '');
      });
    }

    return normalizeText(parts.join(' ')).toLowerCase();
  }

  function findCheckboxByTerms(terms) {
    var form = getProductForm();
    var scopes = [root];
    var checkboxes = [];

    if (form && form !== root && !root.contains(form)) scopes.push(form);

    scopes.forEach(function (scope) {
      if (!scope) return;

      scope.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        if (checkboxes.indexOf(input) === -1) checkboxes.push(input);
      });
    });

    return checkboxes.find(function (input) {
      var text = getCheckboxLabelText(input);

      return terms.every(function (term) {
        return text.indexOf(term.toLowerCase()) !== -1;
      });
    }) || null;
  }

  function isAddOnSelected(type) {
    var checkbox = type === 'ab'
      ? findCheckboxByTerms(['ab', 'diamonds'])
      : findCheckboxByTerms(['priority']);

    return !!(checkbox && checkbox.checked);
  }

  function getEnhancementPriceDelta(sizeKey, shape, enhancement) {
    var standardVariant = findVariantForSelection(sizeKey, shape, ENHANCEMENT_STANDARD);
    var enhancedVariant = findVariantForSelection(sizeKey, shape, enhancement);

    if (!standardVariant || !enhancedVariant) return null;

    return Math.max(0, (Number(enhancedVariant.price) || 0) - (Number(standardVariant.price) || 0));
  }

  function formatAddonPrice(cents) {
    var amount = (Number(cents) || 0) / 100;

    return 'A$' + (amount % 1 === 0 ? String(amount) : amount.toFixed(2));
  }

  function updateAddOnControls(selectedSize, selectedShape) {
    var sizeKey = getSizeKey(selectedSize);
    var abPrice = getEnhancementPriceDelta(sizeKey, selectedShape, ENHANCEMENT_AB);
    var abPriceText = abPrice === null ? '+A$3 / +A$5' : '+' + formatAddonPrice(abPrice);

    if (els.abLabel) {
      els.abLabel.textContent = 'Add AB Diamonds (' + abPriceText + ')';
    }

    [els.abCheckbox, els.priorityCheckbox].forEach(function (checkbox) {
      var card = checkbox ? checkbox.closest('.dp-preview__addon-card') : null;
      if (card) card.classList.toggle('is-selected', checkbox.checked);
    });
  }

  function updateCartUi(cartData) {
    updateCartCountBubble(cartData);
    refreshCartSections(cartData);

    [0, 250, 800, 1600].forEach(function (delay) {
      window.setTimeout(function () {
        updateCartCountBubble(cartData);
        replaceCartImagesForCustomKits(cartData);
        formatCartUploadedPhotoLinks(cartData);
      }, delay);
    });
  }

  function updateCartCountBubble(cartData) {
    var itemCount = cartData && typeof cartData.item_count === 'number' ? cartData.item_count : null;
    var selectors = [
      '[data-cart-count-bubble]',
      '[data-cart-count]',
      '[data-header-cart-count]',
      '[data-cart-count-number]',
      '.cart-count',
      '.cart__count',
      '.cart-link__bubble-num',
      '.site-header__cart-count',
      '.header__cart-count',
      '.header-cart-count',
      '.cart-count-bubble [aria-hidden="true"]',
      '.cart-count-bubble span:first-child'
    ];
    var found = [];
    var cartIcon = document.getElementById('cart-icon-bubble');
    var cartLink = cartIcon || document.querySelector('header a[href$="/cart"], header a[href*="/cart"], a[href="/cart"]');
    var dawnBubble = cartIcon ? cartIcon.querySelector('.cart-count-bubble') : document.querySelector('.cart-count-bubble');

    if (itemCount === null) return;

    if (itemCount > 0 && cartLink && !dawnBubble) {
      dawnBubble = document.createElement('div');
      dawnBubble.className = 'cart-count-bubble';
      dawnBubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      cartLink.appendChild(dawnBubble);
    }

    if (dawnBubble) {
      found.push(dawnBubble);
      dawnBubble.hidden = itemCount <= 0;
      dawnBubble.classList.toggle('is-empty', itemCount <= 0);

      if (dawnBubble.querySelector('[aria-hidden="true"]')) {
        dawnBubble.querySelector('[aria-hidden="true"]').textContent = String(itemCount);
      } else {
        dawnBubble.textContent = String(itemCount);
      }

      if (dawnBubble.querySelector('.visually-hidden')) {
        dawnBubble.querySelector('.visually-hidden').textContent = itemCount === 1
          ? '1 item'
          : itemCount + ' items';
      }
    }

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        if (found.indexOf(element) !== -1) return;
        if (element.id === 'cart-icon-bubble') return;
        if (element.classList && element.classList.contains('cart-count-bubble')) return;

        found.push(element);
        element.textContent = String(itemCount);
        element.hidden = itemCount <= 0;
        element.classList.toggle('is-empty', itemCount <= 0);
      });
    });

    console.log('[Diamond Preview] cart count bubble update', {
      itemCount: itemCount,
      found: found.length > 0,
      updatedCount: found.length
    });
  }

  function replaceSectionHtml(sectionId, html) {
    var container = document.createElement('div');
    var incoming;
    var current;

    if (!html) return false;

    container.innerHTML = html;
    incoming = container.querySelector('#' + sectionId) || container.querySelector(sectionId);
    current = document.querySelector('#' + sectionId) || document.querySelector(sectionId);

    if (!incoming || !current) return false;

    current.replaceWith(incoming);
    return true;
  }

  function refreshCartSections(cartData) {
    var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    var cartUrl = rootUrl.replace(/\/?$/, '/') + 'cart';
    var sectionsUrl = cartUrl + '?sections=cart-icon-bubble&sections_url=' +
      encodeURIComponent(window.location.pathname || '/');

    fetch(sectionsUrl, {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response && response.ok ? response.json() : null;
      })
      .then(function (sections) {
        var replaced = [];

        if (!sections) return;

        if (replaceSectionHtml('cart-icon-bubble', sections['cart-icon-bubble'])) replaced.push('cart-icon-bubble');

        updateCartCountBubble(cartData);

        console.log('[Diamond Preview] cart sections refreshed', {
          requested: ['cart-icon-bubble'],
          replaced: replaced,
          itemCount: cartData && cartData.item_count
        });
      })
      .catch(function (error) {
        console.warn('[Diamond Preview] cart section refresh failed', error);
      });
  }

  function dispatchCartRefreshEvents(cartData) {
    var events = [
      'cart:refresh',
      'cart:updated',
      'theme:cart:change'
    ];

    events.forEach(function (eventName) {
      var eventDetail = {
        cart: cartData,
        item_count: cartData && cartData.item_count
      };

      document.dispatchEvent(new CustomEvent(eventName, {
        bubbles: true,
        detail: eventDetail
      }));

      window.dispatchEvent(new CustomEvent(eventName, {
        bubbles: false,
        detail: eventDetail
      }));

      document.documentElement.dispatchEvent(new CustomEvent(eventName, {
        bubbles: false,
        detail: eventDetail
      }));
    });

    console.log('[Diamond Preview] cart refresh events dispatched', events);
  }

  function callIfFunction(owner, methodName, cartData, called) {
    if (owner && typeof owner[methodName] === 'function') {
      owner[methodName](cartData);
      called.push(methodName);
    }
  }

  function refreshThemeCartUi(cartData) {
    var called = [];
    var cartDrawer = window.Shopify && window.Shopify.theme ? window.Shopify.theme.cartDrawer : null;
    var drawerElement = document.querySelector('cart-drawer, cart-notification, [data-cart-drawer], .cart-drawer');

    dispatchCartRefreshEvents(cartData);

    try {
      if (cartDrawer) {
        callIfFunction(cartDrawer, 'refresh', cartData, called);
        callIfFunction(cartDrawer, 'renderContents', cartData, called);
        callIfFunction(cartDrawer, 'updateCart', cartData, called);
      }

      if (drawerElement) {
        callIfFunction(drawerElement, 'refresh', cartData, called);
        callIfFunction(drawerElement, 'renderContents', cartData, called);
        callIfFunction(drawerElement, 'updateCart', cartData, called);
      }
    } catch (error) {
      console.warn('[Diamond Preview] cart drawer refresh hook failed', error);
    }

    console.log('[Diamond Preview] cart drawer refresh hooks', {
      drawerElementFound: !!drawerElement,
      shopifyThemeCartDrawerFound: !!cartDrawer,
      called: called
    });
  }

  function getCartPreviewStorageKey(customKitId) {
    return 'dp-cart-preview-image:' + customKitId;
  }

  function getCartPreviewStorageKeyFromUrl(uploadedPhotoUrl) {
    return 'dp-cart-preview-image-url:' + uploadedPhotoUrl;
  }

  function createCartPreviewImageUrl() {
    var source = els.canvas;
    var maxSize = 420;
    var scale;
    var canvas;
    var ctx;

    if (!source || !source.width || !source.height) return state.imageUrl || '';

    scale = Math.min(1, maxSize / Math.max(source.width, source.height));
    canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(source.width * scale));
    canvas.height = Math.max(1, Math.round(source.height * scale));
    ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(source, 0, 0, canvas.width, canvas.height);

    try {
      return canvas.toDataURL('image/jpeg', 0.82);
    } catch (error) {
      return state.imageUrl || '';
    }
  }

  function getLineItemCustomKitId(item) {
    var properties = item && item.properties ? item.properties : {};

    return properties['Custom Kit ID'] || properties['_Custom Kit ID'] || '';
  }

  function getLineItemUploadedPhotoUrl(item) {
    var properties = item && item.properties ? item.properties : {};

    return properties['Uploaded Photo URL'] || '';
  }

  function setCartImageElement(img, imageUrl) {
    if (!img || !imageUrl) return;

    img.src = imageUrl;
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
    img.style.objectFit = 'cover';
  }

  function findCartLineElement(item, customKitId) {
    var escapeCss = window.CSS && CSS.escape
      ? CSS.escape
      : function (value) {
        return String(value).replace(/"/g, '\\"');
      };
    var selectors = [
      '[data-cart-item]',
      '[data-cart-item-key]',
      '[data-line-item-key]',
      '.cart-item',
      '.cart__item',
      '.cart-drawer-item',
      '.drawer__cart-item',
      'tr',
      'li',
      'div'
    ];
    var key = item && item.key ? String(item.key) : '';
    var variantId = item && item.variant_id ? String(item.variant_id) : '';
    var uploadedPhotoUrl = getLineItemUploadedPhotoUrl(item);
    var url = item && item.url ? String(item.url).split('?')[0] : '';
    var candidates = [];
    var match = null;

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        if (candidates.indexOf(element) === -1) candidates.push(element);
      });
    });

    match = candidates.find(function (element) {
      return customKitId && normalizeText(element.textContent).indexOf(customKitId) !== -1;
    });
    if (match) return match;

    match = candidates.find(function (element) {
      return uploadedPhotoUrl && normalizeText(element.textContent).indexOf(uploadedPhotoUrl) !== -1;
    });
    if (match) return match;

    match = candidates.find(function (element) {
      return key && (
        element.getAttribute('data-cart-item-key') === key ||
        element.getAttribute('data-line-item-key') === key ||
        element.querySelector('[href*="' + escapeCss(key) + '"]')
      );
    });
    if (match) return match;

    match = candidates.find(function (element) {
      var link = url ? element.querySelector('a[href*="' + url + '"]') : null;
      var variantMatch = variantId && normalizeText(element.innerHTML).indexOf(variantId) !== -1;

      return !!link || !!variantMatch;
    });

    return match || null;
  }

  function replaceCartImagesForCustomKits(cartData) {
    var items = cartData && Array.isArray(cartData.items) ? cartData.items : [];

    items.forEach(function (item) {
      var customKitId = getLineItemCustomKitId(item);
      var uploadedPhotoUrl = getLineItemUploadedPhotoUrl(item);
      var imageUrl;
      var lineElement;
      var img;

      if (!uploadedPhotoUrl && !customKitId) return;

      try {
        imageUrl = customKitId ? window.sessionStorage.getItem(getCartPreviewStorageKey(customKitId)) : '';
      } catch (error) {
        imageUrl = '';
      }

      if (!imageUrl) {
        try {
          imageUrl = uploadedPhotoUrl ? window.sessionStorage.getItem(getCartPreviewStorageKeyFromUrl(uploadedPhotoUrl)) : '';
        } catch (error) {
          imageUrl = '';
        }
      }

      if (!imageUrl) imageUrl = uploadedPhotoUrl;
      if (!imageUrl) return;

      lineElement = findCartLineElement(item, customKitId);
      img = lineElement ? lineElement.querySelector('img') : null;

      if (!img) return;

      setCartImageElement(img, imageUrl);
    });
  }

  function getCartPropertyValue(item, propertyName) {
    var properties = item && item.properties ? item.properties : {};

    return properties[propertyName] || '';
  }

  function findCartPropertyElement(lineElement, propertyName, propertyValue) {
    var label = normalizeText(propertyName).toLowerCase();
    var value = normalizeText(propertyValue);
    var candidates = [];

    if (!lineElement) return null;

    lineElement.querySelectorAll('li, dd, dt, p, div, span').forEach(function (element) {
      var text = normalizeText(element.textContent);
      var lowerText = text.toLowerCase();

      if (element === lineElement) return;
      if (element.querySelector('img, picture, button, input, select, textarea, form')) return;
      if (element.children.length > 8) return;
      if (!text || text.length > 700) return;
      if (lowerText.indexOf(label) === -1 && (!value || text.indexOf(value) === -1)) return;

      candidates.push(element);
    });

    return candidates.sort(function (a, b) {
      return normalizeText(a.textContent).length - normalizeText(b.textContent).length;
    })[0] || null;
  }

  function formatUploadedPhotoProperty(lineElement, uploadedPhotoUrl) {
    var element = findCartPropertyElement(lineElement, 'Uploaded Photo URL', uploadedPhotoUrl) ||
      findCartPropertyElement(lineElement, 'Uploaded Photo', uploadedPhotoUrl);
    var link;

    if (!element || !uploadedPhotoUrl) return;

    element.innerHTML = '';
    element.appendChild(document.createTextNode('Uploaded Photo: '));

    link = document.createElement('a');
    link.href = uploadedPhotoUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = 'View image';
    element.appendChild(link);
  }

  function moveUploadedPhotoPropertyToTop(lineElement, uploadedPhotoUrl) {
    var element = findCartPropertyElement(lineElement, 'Uploaded Photo', uploadedPhotoUrl);
    var parent;

    if (!element) return;

    parent = element.parentElement;
    if (parent && parent.firstElementChild !== element) {
      parent.insertBefore(element, parent.firstElementChild);
    }
  }

  function formatCartUploadedPhotoLinks(cartData) {
    var items = cartData && Array.isArray(cartData.items) ? cartData.items : [];

    items.forEach(function (item) {
      var customKitId = getLineItemCustomKitId(item);
      var lineElement = findCartLineElement(item, customKitId);
      var uploadedPhotoUrl = getCartPropertyValue(item, 'Uploaded Photo URL');

      if (!lineElement || !uploadedPhotoUrl) return;

      formatUploadedPhotoProperty(lineElement, uploadedPhotoUrl);
      moveUploadedPhotoPropertyToTop(lineElement, uploadedPhotoUrl);
    });
  }

  function fetchAndFormatCartProperties() {
    fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response && response.ok ? response.json() : null;
      })
      .then(function (cartData) {
        replaceCartImagesForCustomKits(cartData);
        formatCartUploadedPhotoLinks(cartData);
      })
      .catch(function () {});
  }

  function fetchCartData() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      return response && response.ok ? response.json() : null;
    });
  }

  function findEditedCartItemKey(cartData) {
    var items = cartData && Array.isArray(cartData.items) ? cartData.items : [];

    if (state.editCartItemKey) return state.editCartItemKey;

    return items.reduce(function (match, item) {
      var uploadedPhotoUrl = getCartPropertyValue(item, 'Uploaded Photo URL');

      if (match) return match;
      if (state.editOriginalPhotoUrl && uploadedPhotoUrl === state.editOriginalPhotoUrl) return item.key;

      return '';
    }, '');
  }

  function removeEditedCartLineIfNeeded() {
    if (!state.isCartEdit) return Promise.resolve(null);

    return fetchCartData()
      .then(function (cartData) {
        var itemKey = findEditedCartItemKey(cartData);

        if (!itemKey) {
          console.warn('[Diamond Preview] Could not find original cart line to update; adding as a new item.');
          return null;
        }

        console.log('[Diamond Preview] removing original edited cart line before re-add', {
          itemKey: itemKey,
          originalPhotoUrl: state.editOriginalPhotoUrl
        });

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            id: itemKey,
            quantity: 0
          })
        }).then(function (response) {
          if (!response.ok) {
            return response.json().catch(function () {
              return {};
            }).then(function (error) {
              console.error('[Diamond Preview] failed to remove original edited cart line', error);
              throw error;
            });
          }

          state.editCartItemKey = '';
          state.isCartEdit = false;
          return response.json().catch(function () {
            return null;
          });
        });
      });
  }

  function debugVariantState(label, variant) {
    var size = getSizeFromVariant(variant);

    console.log('[Diamond Preview]', label, {
      selectedSize: size ? size.label : null,
      selectedShape: getShapeFromVariant(variant),
      selectedEnhancement: getSelectedEnhancement(),
      matchedVariantId: variant ? variant.id : null,
      matchedVariantTitle: variant ? variant.title : null,
    matchedVariantAvailable: variant ? variant.available : null,
      enhancement: getEnhancementFromVariant(variant),
      price: variant ? variant.price : null,
      customKitId: state.customKitId,
      uploadedFileName: state.uploadedFileName
    });
  }

  function getSizeByKey(sizeKey) {
    return getAvailableSizes().find(function (size) {
      return getSizeKey(size) === sizeKey;
    }) || null;
  }

  function findVariantForSelection(sizeKey, shape, enhancement) {
    var targetEnhancement = enhancement || getSelectedEnhancement();
    var matches = (product.variants || []).filter(function (variant) {
      return sizeKeysMatch(getSizeKey(getSizeFromVariant(variant)), sizeKey) &&
        shapesMatch(getShapeFromVariant(variant), shape) &&
        enhancementsMatch(getEnhancementFromVariant(variant), targetEnhancement);
    });

    var match = matches.find(isVariantAvailable) || null;

    console.log('[Diamond Preview] variant match attempt', {
      selectedDiamondType: shape,
      selectedSize: sizeKey,
      selectedEnhancement: targetEnhancement,
      matchedVariant: match,
      matchedVariantId: match ? match.id : null,
      matchedVariantAvailable: match ? match.available : null,
      allAvailableVariantOptionValues: getVariantDebugRows()
    });

    if (!match) {
      console.warn('[Diamond Preview] no matching available variant found', {
        selectedDiamondType: shape,
        selectedSize: sizeKey,
        selectedEnhancement: targetEnhancement,
        allVariants: getVariantDebugRows()
      });
    }

    return match;
  }

  function findAnyVariantForSizeAndShape(sizeKey, shape) {
    var matches = (product.variants || []).filter(function (variant) {
      return sizeKeysMatch(getSizeKey(getSizeFromVariant(variant)), sizeKey) &&
        shapesMatch(getShapeFromVariant(variant), shape);
    });

    return matches.find(isVariantAvailable) || null;
  }

  function getSourceDimensions() {
    if (!state.image) return null;

    var rotated = state.rotation % 180 !== 0;
    return {
      width: rotated ? state.image.naturalHeight : state.image.naturalWidth,
      height: rotated ? state.image.naturalWidth : state.image.naturalHeight
    };
  }

  function getOrientedSize(size, sourceDimensions) {
    if (!size) return null;

    var small = Math.min(size.a, size.b);
    var large = Math.max(size.a, size.b);

    if (small === large) {
      return {
        widthCm: size.a,
        heightCm: size.b,
        orientation: 'Square'
      };
    }

    if (!sourceDimensions) {
      return {
        widthCm: size.a,
        heightCm: size.b,
        orientation: size.a >= size.b ? 'Landscape' : 'Portrait'
      };
    }

    if (sourceDimensions.width >= sourceDimensions.height) {
      return {
        widthCm: large,
        heightCm: small,
        orientation: 'Landscape'
      };
    }

    return {
      widthCm: small,
      heightCm: large,
      orientation: 'Portrait'
    };
  }

  function getGrid(size, sourceDimensions) {
    var oriented = getOrientedSize(size, sourceDimensions);
    if (!oriented) return null;

    return {
      widthCm: oriented.widthCm,
      heightCm: oriented.heightCm,
      orientation: oriented.orientation,
      widthDiamonds: Math.round(oriented.widthCm * DRILLS_PER_CM),
      heightDiamonds: Math.round(oriented.heightCm * DRILLS_PER_CM)
    };
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function renderOptionControls() {
    var variant = getSelectedVariant();
    var selectedSize = getSizeFromVariant(variant);
    var selectedSizeKey = state.hasChosenSize ? getSizeKey(selectedSize) : '';
    var selectedShape = getShapeFromVariant(variant);
    var sourceDimensions = getSourceDimensions();
    var recommendedMinimumKey = getRecommendedMinimumSizeKey(sourceDimensions, selectedShape);
    var recommendedMinimumSize = getSizeByKey(recommendedMinimumKey);
    var sizes = sourceDimensions
      ? (state.showAllSizes ? getAvailableSizes() : getClosestRatioSizes(sourceDimensions))
      : [];
    var shapes = getAvailableShapes();

    els.panelEmpty.hidden = !!state.image;
    els.sizeHelp.hidden = !state.image;
    if (state.image && recommendedMinimumSize) {
      els.sizeHelp.textContent = selectedSize && getSizeArea(selectedSize) < getSizeArea(recommendedMinimumSize)
        ? 'For best results, we recommend at least ' + recommendedMinimumSize.label + ' for this photo.'
        : 'This size is suitable for your uploaded photo.';
    } else {
      els.sizeHelp.textContent = '';
    }

    els.sizeOptions.innerHTML = sizes.map(function (size) {
      var sizeKey = getSizeKey(size);
      var hasVariant = !!findVariantForSize(sizeKey);
      var isLowerDetail = recommendedMinimumSize && getSizeArea(size) < getSizeArea(recommendedMinimumSize);

      return '<button class="dp-preview__option-button' +
        (sizeKey === selectedSizeKey ? ' is-selected' : '') +
        (isLowerDetail ? ' is-lower-detail' : '') +
        '" data-dp-size-key="' + escapeHtml(sizeKey) + '" type="button"' +
        (state.image && hasVariant ? '' : ' disabled') +
        '>' + escapeHtml(size.label) +
        (isLowerDetail ? '<span class="dp-preview__option-subtext">Basic detail</span>' : '') +
        (sizeKey === recommendedMinimumKey ? '<span class="dp-preview__option-badge">Recommended Minimum</span>' : '') +
        '</button>';
    }).join('') + (state.image
      ? '<button class="dp-preview__option-button dp-preview__option-button--custom" data-dp-toggle-custom-size type="button">' +
        '<small>Advanced</small><span>Custom Size</span><span>' +
        (state.showAllSizes ? 'Show recommended sizes' : 'Choose any available size') +
        '</span></button>'
      : '');

    els.shapeOptions.innerHTML = shapes.map(function (shape) {
      var hasVariant = selectedSizeKey ? !!findAnyVariantForSizeAndShape(selectedSizeKey, shape) : false;

      return '<button class="dp-preview__option-button' +
        (shape === selectedShape ? ' is-selected' : '') +
        '" data-dp-shape="' + escapeHtml(shape) + '" type="button"' +
        (state.image && hasVariant ? '' : ' disabled') +
      '>' + escapeHtml(shape) + '</button>';
    }).join('');

  }

  function ratioDiff(a, b) {
    return Math.abs(Math.log(a / b));
  }

  function getClosestRatioSizes(sourceDimensions) {
    var sizes = getAvailableSizes();
    var imageRatio = sourceDimensions
      ? Math.max(sourceDimensions.width, sourceDimensions.height) / Math.min(sourceDimensions.width, sourceDimensions.height)
      : null;
    var bestRatioKey = '';
    var bestDiff = null;

    if (!imageRatio) return [];

    sizes.forEach(function (size) {
      var small = Math.min(size.a, size.b);
      var large = Math.max(size.a, size.b);
      var ratio = large / small;
      var diff = ratioDiff(imageRatio, ratio);

      if (bestDiff === null || diff < bestDiff) {
        bestDiff = diff;
        bestRatioKey = getSizeRatioKey(size);
      }
    });

    return sizes.filter(function (size) {
      return getSizeRatioKey(size) === bestRatioKey;
    }).sort(function (a, b) {
      return getSizeArea(a) - getSizeArea(b);
    });
  }

  function getDefaultSizeForImage(sourceDimensions) {
    var sizes = getClosestRatioSizes(sourceDimensions);
    var squareSizes = sizes.filter(function (size) {
      return size.a === size.b;
    });

    if (!sizes.length) return null;

    if (squareSizes.length) {
      return squareSizes.find(function (size) {
        return size.a === 40 && size.b === 40;
      }) || squareSizes[0];
    }

    return sizes[0];
  }

  function selectDefaultSizeForImage() {
    var defaultSize = getDefaultSizeForImage(getSourceDimensions());
    var variant = defaultSize ? findVariantForSize(getSizeKey(defaultSize)) : null;

    if (!variant) return false;

    state.hasChosenSize = true;
    applyProgrammaticVariant(variant);

    return true;
  }

  function getAvailableSizeKeys() {
    return getAvailableSizes().map(function (size) {
      return getSizeKey(size);
    });
  }

  function getParsedAvailableSizes() {
    var seen = {};
    var parsed = [];

    (product.variants || []).forEach(function (variant) {
      var size = getSizeFromVariant(variant);
      var sizeKey;
      var small;
      var large;

      if (!isVariantAvailable(variant) || !size) return;

      sizeKey = getSizeKey(size);
      if (!sizeKey || seen[sizeKey]) return;

      seen[sizeKey] = true;
      small = Math.min(size.a, size.b);
      large = Math.max(size.a, size.b);

      parsed.push({
        key: sizeKey,
        label: size.label,
        width: size.a,
        height: size.b,
        normalizedRatio: large / small,
        area: size.a * size.b
      });
    });

    return parsed;
  }

  function getPreferredDefaultSizeRecommendation(sourceDimensions) {
    var rawRatio;
    var normalizedRatio;
    var ratioGroup = '';
    var sizeKeys = [];
    var minimumArea = 0;

    if (!sourceDimensions || !sourceDimensions.width || !sourceDimensions.height) return '';

    rawRatio = sourceDimensions.width / sourceDimensions.height;
    normalizedRatio = Math.max(rawRatio, 1 / rawRatio);

    if (normalizedRatio >= 0.85 && normalizedRatio <= 1.15) {
      ratioGroup = '1:1';
      sizeKeys = ['40x40'];
      minimumArea = 40 * 40;
    } else if (normalizedRatio > 1.15 && normalizedRatio < 1.35) {
      ratioGroup = '4:5';
      sizeKeys = ['40x50', '45x60'];
      minimumArea = 40 * 50;
    } else if (normalizedRatio >= 1.35 && normalizedRatio < 1.5) {
      ratioGroup = '3:4';
      sizeKeys = ['45x60'];
      minimumArea = 45 * 60;
    } else if (normalizedRatio >= 1.5 && normalizedRatio < 1.85) {
      ratioGroup = '3:5';
      sizeKeys = ['45x75', '60x100'];
      minimumArea = 45 * 75;
    } else if (normalizedRatio >= 1.85 && normalizedRatio <= 2.25) {
      ratioGroup = '1:2';
      sizeKeys = ['40x80', '50x100'];
      minimumArea = 40 * 80;
    } else {
      ratioGroup = 'nearest';
    }

    return {
      rawRatio: rawRatio,
      normalizedRatio: normalizedRatio,
      ratioGroup: ratioGroup,
      sizeKeys: sizeKeys,
      minimumArea: minimumArea
    };
  }

  function findFallbackDefaultSize(recommendation) {
    var availableSizes = getParsedAvailableSizes();
    var normalizedImageRatio = recommendation ? recommendation.normalizedRatio : null;
    var minimumArea = recommendation ? recommendation.minimumArea : 0;
    var ratioTieThreshold = 0.04;
    var candidates;
    var best = null;

    if (!normalizedImageRatio || !availableSizes.length) {
      return {
        sizeKey: '',
        variant: null,
        reason: 'No image ratio or available sizes.',
        availableSizes: availableSizes
      };
    }

    candidates = availableSizes.map(function (size) {
      return {
        size: size,
        ratioDifference: Math.abs(size.normalizedRatio - normalizedImageRatio),
        meetsMinimumArea: minimumArea ? size.area >= minimumArea : true
      };
    });

    candidates.sort(function (a, b) {
      if (a.meetsMinimumArea !== b.meetsMinimumArea) {
        return a.meetsMinimumArea ? -1 : 1;
      }

      if (Math.abs(a.ratioDifference - b.ratioDifference) <= ratioTieThreshold) {
        return b.size.area - a.size.area;
      }

      return a.ratioDifference - b.ratioDifference;
    });

    best = candidates[0] || null;

    return {
      sizeKey: best ? best.size.key : '',
      variant: best ? findVariantForSize(best.size.key) : null,
      reason: best
        ? (best.meetsMinimumArea ? 'nearest ratio with minimum size preference' : 'nearest ratio; no size met minimum area')
        : 'No fallback candidate found.',
      availableSizes: availableSizes,
      ratioDifference: best ? best.ratioDifference : null
    };
  }

  function applyProgrammaticVariant(variant) {
    var applied;

    if (!variant) return false;

    state.isProgrammaticSizeChange = true;
    try {
      applied = applyVariantToForm(variant);
    } finally {
      state.isProgrammaticSizeChange = false;
    }

    return applied;
  }

  function selectRecommendedDefaultSizeForImage() {
    var recommendation;
    var preferredSizeKey = '';
    var variant;
    var fallback = null;
    var selectedReason = '';
    var sourceDimensions = getSourceDimensions();
    var availableSizeKeys = getAvailableSizeKeys();

    if (state.userHasManuallySelectedSize) {
      console.log('[Diamond Preview] auto default size skipped', {
        imageWidth: sourceDimensions ? sourceDimensions.width : null,
        imageHeight: sourceDimensions ? sourceDimensions.height : null,
        rawRatio: sourceDimensions && sourceDimensions.width && sourceDimensions.height
          ? sourceDimensions.width / sourceDimensions.height
          : null,
        normalizedRatio: sourceDimensions && sourceDimensions.width && sourceDimensions.height
          ? Math.max(sourceDimensions.width / sourceDimensions.height, sourceDimensions.height / sourceDimensions.width)
          : null,
        userHasManuallySelectedSize: state.userHasManuallySelectedSize,
        reason: 'manual size already selected',
        preferredSizeList: [],
        selectedFallbackSize: '',
        availableSizeKeys: availableSizeKeys
      });
      return false;
    }

    recommendation = getPreferredDefaultSizeRecommendation(sourceDimensions);

    if (recommendation && recommendation.sizeKeys) {
      recommendation.sizeKeys.some(function (sizeKey) {
        var matchedVariant = findVariantForSize(sizeKey);

        if (!matchedVariant) return false;

        preferredSizeKey = sizeKey;
        variant = matchedVariant;
        selectedReason = 'exact preferred size available';
        return true;
      });
    }

    if (!variant) {
      fallback = findFallbackDefaultSize(recommendation);
      preferredSizeKey = fallback.sizeKey;
      variant = fallback.variant;
      selectedReason = fallback.reason;
    }

    console.log('[Diamond Preview] auto default size recommendation', {
      imageWidth: sourceDimensions ? sourceDimensions.width : null,
      imageHeight: sourceDimensions ? sourceDimensions.height : null,
      rawRatio: recommendation ? recommendation.rawRatio : null,
      normalizedRatio: recommendation ? recommendation.normalizedRatio : null,
      selectedRatioGroup: recommendation ? recommendation.ratioGroup : '',
      preferredSizeList: recommendation ? recommendation.sizeKeys : [],
      selectedRecommendedSize: preferredSizeKey,
      selectedFallbackSize: fallback ? fallback.sizeKey : '',
      reasonSelected: selectedReason,
      userHasManuallySelectedSize: state.userHasManuallySelectedSize,
      foundMatchingVariant: !!variant,
      matchedVariantId: variant ? variant.id : null,
      matchedVariantTitle: variant ? variant.title : null,
      availableParsedSizes: fallback ? fallback.availableSizes : getParsedAvailableSizes(),
      availableSizeKeys: availableSizeKeys
    });

    if (variant) {
      state.hasChosenSize = true;
      applyProgrammaticVariant(variant);
      return true;
    }

    return selectDefaultSizeForImage();
  }

  function getRecommendedMinimumSizeKey(sourceDimensions, shape) {
    var defaultSize = getDefaultSizeForImage(sourceDimensions);
    var defaultRatioKey = getSizeRatioKey(defaultSize);
    var defaultArea = getSizeArea(defaultSize);
    var candidates = [];

    if (!defaultSize || !defaultRatioKey) return '';

    (product.variants || []).forEach(function (variant) {
      var size = getSizeFromVariant(variant);

      if (!size) return;
      if (shape && getShapeFromVariant(variant) !== shape) return;
      if (getSizeRatioKey(size) !== defaultRatioKey) return;
      if (getSizeArea(size) <= defaultArea) return;

      candidates.push(size);
    });

    candidates.sort(function (a, b) {
      return getSizeArea(a) - getSizeArea(b);
    });

    return getSizeKey(candidates[0] || defaultSize);
  }

  function findBetterSize(selectedSize, sourceDimensions) {
    if (!selectedSize || !sourceDimensions) return null;

    var sizes = getAvailableSizes();
    var imageRatio = sourceDimensions.width / sourceDimensions.height;
    var selectedGrid = getGrid(selectedSize, sourceDimensions);
    var selectedDiff = ratioDiff(imageRatio, selectedGrid.widthDiamonds / selectedGrid.heightDiamonds);
    var best = null;

    sizes.forEach(function (size) {
      var grid = getGrid(size, sourceDimensions);
      if (!grid) return;

      var diff = ratioDiff(imageRatio, grid.widthDiamonds / grid.heightDiamonds);
      if (!best || diff < best.diff) {
        best = {
          size: size,
          grid: grid,
          diff: diff
        };
      }
    });

    if (!best || best.diff + 0.025 >= selectedDiff) return null;

    var selectedKey = getSizeKey(selectedSize);
    var bestKey = getSizeKey(best.size);

    return selectedKey === bestKey ? null : best;
  }

  function updateSuggestion() {
    if (!state.image || !state.hasChosenSize) {
      els.suggestion.hidden = true;
      els.suggestion.textContent = '';
      state.recommendedSizeKey = '';
      return;
    }

    var variant = getSelectedVariant();
    var selectedSize = getSizeFromVariant(variant);
    var better = findBetterSize(selectedSize, getSourceDimensions());

    if (!better) {
      els.suggestion.hidden = true;
      els.suggestion.textContent = '';
      state.recommendedSizeKey = '';
      return;
    }

    state.recommendedSizeKey = getSizeKey(better.size);
    els.suggestion.hidden = false;
    els.suggestion.innerHTML =
      '<strong>Size suggestion:</strong> This image ratio is closer to ' +
      escapeHtml(better.size.label) +
      ' (' + escapeHtml(better.grid.widthCm + 'x' + better.grid.heightCm + 'cm') +
      '), so that variant should crop less of the uploaded photo. ' +
      '<button class="dp-preview__suggestion-button" data-dp-apply-suggestion type="button">Change Painting</button>';
  }

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'AUD';

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function findUpgradeVariant() {
    var currentVariant = getSelectedVariant();
    var currentSize = getSizeFromVariant(currentVariant);
    var currentShape = getShapeFromVariant(currentVariant);
    var currentRatioKey = getSizeRatioKey(currentSize);
    var currentArea = getSizeArea(currentSize);
    var candidates = [];

    if (!currentVariant || !currentSize || !currentRatioKey) return null;

    (product.variants || []).forEach(function (variant) {
      var size = getSizeFromVariant(variant);

      if (!size) return;
      if (getShapeFromVariant(variant) !== currentShape) return;
      if (getSizeRatioKey(size) !== currentRatioKey) return;
      if (getSizeArea(size) <= currentArea) return;

      candidates.push({
        variant: variant,
        size: size,
        area: getSizeArea(size)
      });
    });

    candidates.sort(function (a, b) {
      return a.area - b.area;
    });

    return candidates[0] || null;
  }

  function updateUpgrade() {
    els.upgrade.hidden = true;
    els.upgrade.textContent = '';
  }

  function updateSubmitState() {
    var form = getProductForm();
    var baseVariant = getSelectedVariant();
    var matchedVariant = getMatchedSelectedVariant();
    var selectedSize = getSizeFromVariant(baseVariant);
    var selectedShape = getShapeFromVariant(baseVariant);
    var selectedSizeKey = getSizeKey(selectedSize);
    var selectedEnhancement = getSelectedEnhancement();
    var uploadComplete = !!state.uploadedPhotoUrl && !state.isUploadingPhoto && !state.photoUploadError;
    var canSubmit = !!state.image && uploadComplete && !!state.hasChosenSize && isVariantAvailable(matchedVariant);
    var selectedPriceCents = matchedVariant && matchedVariant.price !== undefined
      ? Number(matchedVariant.price) || 0
      : null;
    var selectedPrice;

    updateAddOnControls(selectedSize, selectedShape);

    selectedPrice = selectedPriceCents !== null
      ? ' \u2014 ' + formatMoney(selectedPriceCents)
      : '';

    if (form && matchedVariant) {
      form.querySelectorAll('[name="id"]').forEach(function (input) {
        input.value = matchedVariant.id;
      });

      state.selectedVariantId = String(matchedVariant.id);
      state.lastVariantId = String(matchedVariant.id);
    }

    console.log('[Diamond Preview] submit state', {
      selectedDiamondType: selectedShape,
      selectedSize: selectedSizeKey,
      selectedEnhancement: selectedEnhancement,
      matchedVariant: matchedVariant,
      matchedVariantId: matchedVariant ? matchedVariant.id : null,
      matchedVariantAvailability: matchedVariant ? matchedVariant.available : null,
      hiddenInputValue: form && form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : null,
      isUploadingPhoto: state.isUploadingPhoto,
      uploadedPhotoUrl: state.uploadedPhotoUrl,
      uploadedPhotoKey: state.uploadedPhotoKey,
      photoUploadError: state.photoUploadError,
      canSubmit: canSubmit,
      unavailableReason: state.image && state.hasChosenSize && !isVariantAvailable(matchedVariant)
        ? 'This combination is unavailable or no matching variant was found.'
        : ''
    });

    if (els.addToCart) {
      els.addToCart.disabled = !canSubmit || state.isAddingToCart;
      els.addToCart.textContent = state.isAddingToCart
        ? 'Adding...'
        : state.isUploadingPhoto
        ? 'Uploading photo...'
        : state.image
        ? (state.isCartEdit ? 'Update Cart' : 'Add to Cart') + selectedPrice
        : 'Add to Cart';
    }

    if (els.continueNote) {
      els.continueNote.textContent = state.photoUploadError
        ? state.photoUploadError
        : state.isUploadingPhoto
        ? 'Uploading photo...'
        : state.image && !state.uploadedPhotoUrl
        ? 'Please wait for your photo upload to finish before adding to cart.'
        : state.image && state.hasChosenSize && !isVariantAvailable(matchedVariant)
        ? 'This combination is unavailable.'
        : state.image
        ? 'You can still change your photo, size or diamond type before checkout.'
        : 'Upload your photo before adding to cart.';
    }

    if (!form) return;

    form.querySelectorAll('button[type="submit"], input[type="submit"], button[name="add"]').forEach(function (button) {
      if (!button.hasAttribute('data-dp-original-disabled')) {
        button.setAttribute('data-dp-original-disabled', button.disabled ? 'true' : 'false');
      }

      button.disabled = button.getAttribute('data-dp-original-disabled') === 'true' || !canSubmit || state.isAddingToCart;
      button.setAttribute('aria-disabled', canSubmit && !state.isAddingToCart ? 'false' : 'true');
    });
  }

  function findVariantForSize(sizeKey) {
    var currentVariant = getSelectedVariant();
    var currentShape = getShapeFromVariant(currentVariant);
    var matches = (product.variants || []).filter(function (variant) {
      return sizeKeysMatch(getSizeKey(getSizeFromVariant(variant)), sizeKey);
    });

    return matches.find(function (variant) {
      return getShapeFromVariant(variant) === currentShape &&
        getEnhancementFromVariant(variant) === getSelectedEnhancement() &&
        isVariantAvailable(variant);
    }) || matches.find(function (variant) {
      return getShapeFromVariant(variant) === currentShape && isVariantAvailable(variant);
    }) || matches.find(isVariantAvailable) || null;
  }

  function setFormControlValue(control, value) {
    if (!control) return;

    if (control.tagName === 'SELECT') {
      control.value = value;
      control.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    if (control.type === 'radio' || control.type === 'checkbox') {
      control.checked = true;
      control.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function applyVariantToForm(variant) {
    var form = getProductForm();
    if (!form || !variant) return false;

    var options = getVariantOptions(variant);
    var idInput = form.querySelector('[name="id"]');

    options.forEach(function (option) {
      var normalizedOption = normalizeText(option);
      var matched = false;

      form.querySelectorAll('select').forEach(function (select) {
        if (matched || select.name === 'id') return;

        Array.prototype.slice.call(select.options).some(function (selectOption) {
          if (normalizeText(selectOption.value) === normalizedOption || normalizeText(selectOption.textContent) === normalizedOption) {
            setFormControlValue(select, selectOption.value);
            matched = true;
            return true;
          }

          return false;
        });
      });

      if (matched) return;

      form.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (input) {
        if (!matched && input.name !== 'id' && normalizeText(input.value) === normalizedOption) {
          setFormControlValue(input, input.value);
          matched = true;
        }
      });
    });

    if (idInput) {
      form.querySelectorAll('[name="id"]').forEach(function (input) {
        input.value = variant.id;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    state.selectedVariantId = String(variant.id);
    state.lastVariantId = String(variant.id);
    debugVariantState('matched variant applied', variant);
    renderPreview();

    return true;
  }

  function getAllVariantOptionValues() {
    var seen = {};

    (product.variants || []).forEach(function (variant) {
      getVariantOptions(variant).forEach(function (option) {
        seen[normalizeText(option)] = true;
      });
    });

    return seen;
  }

  function hideNativeVariantPickers() {
    var form = getProductForm();
    if (!form) return;

    var optionValues = getAllVariantOptionValues();
    var wrappers = [];

    function addWrapper(control) {
      if (!control || root.contains(control)) return;

      var wrapper = control.closest('variant-radios, variant-selects, .product-form__input, .selector-wrapper, fieldset');
      if (!wrapper || wrapper === form) wrapper = control.parentElement;
      if (wrapper && wrappers.indexOf(wrapper) === -1) wrappers.push(wrapper);
    }

    form.querySelectorAll('select').forEach(function (select) {
      if (select.name === 'id') return;

      var hasVariantOption = Array.prototype.slice.call(select.options).some(function (option) {
        return optionValues[normalizeText(option.value)] || optionValues[normalizeText(option.textContent)];
      });

      if (hasVariantOption) addWrapper(select);
    });

    form.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (input) {
      if (input.name === 'id') return;
      if (optionValues[normalizeText(input.value)]) addWrapper(input);
    });

    wrappers.forEach(function (wrapper) {
      wrapper.setAttribute('data-dp-native-hidden', blockId);
      wrapper.style.display = 'none';
    });
  }

  function makeRotatedCanvas(image) {
    var rotated = state.rotation % 180 !== 0;
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    canvas.width = rotated ? image.naturalHeight : image.naturalWidth;
    canvas.height = rotated ? image.naturalWidth : image.naturalHeight;

    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(state.rotation * Math.PI / 180);
    ctx.drawImage(image, -image.naturalWidth / 2, -image.naturalHeight / 2);

    return canvas;
  }

  function getPreviewCellSize(grid) {
    return Math.max(2, Math.min(6, Math.floor(Math.min(
      MAX_PREVIEW_WIDTH / grid.widthDiamonds,
      MAX_PREVIEW_HEIGHT / grid.heightDiamonds
    ))));
  }

  function drawSquarePreview(sourceCanvas, targetCtx, cellSize) {
    var width = sourceCanvas.width * cellSize;
    var height = sourceCanvas.height * cellSize;

    targetCtx.imageSmoothingEnabled = false;
    targetCtx.drawImage(sourceCanvas, 0, 0, width, height);
  }

  function getMaxColoursForSize(size) {
    if (!size) return SMALL_PAINTING_MAX_COLOURS;

    return Math.min(size.a, size.b) <= 30 && Math.max(size.a, size.b) <= 40
      ? SMALL_PAINTING_MAX_COLOURS
      : LARGE_PAINTING_MAX_COLOURS;
  }

  function limitCanvasColours(canvas, maxColours) {
    if (!maxColours) return;

    var ctx = canvas.getContext('2d');
    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var data = imageData.data;
    var buckets = {};
    var points = [];
    var boxes = [];
    var palette = [];
    var cache = {};

    for (var i = 0; i < data.length; i += 4) {
      var key = (data[i] >> 2) + ',' + (data[i + 1] >> 2) + ',' + (data[i + 2] >> 2);

      if (!buckets[key]) {
        buckets[key] = {
          count: 0,
          r: 0,
          g: 0,
          b: 0
        };
      }

      buckets[key].count += 1;
      buckets[key].r += data[i];
      buckets[key].g += data[i + 1];
      buckets[key].b += data[i + 2];
    }

    points = Object.keys(buckets).map(function (key) {
      var bucket = buckets[key];

      return {
        count: bucket.count,
        r: Math.round(bucket.r / bucket.count),
        g: Math.round(bucket.g / bucket.count),
        b: Math.round(bucket.b / bucket.count)
      };
    });

    function makeBox(boxPoints) {
      var box = {
        points: boxPoints || [],
        count: 0,
        rMin: 255,
        rMax: 0,
        gMin: 255,
        gMax: 0,
        bMin: 255,
        bMax: 0
      };

      if (!box.points.length) {
        box.range = 0;
        return box;
      }

      boxPoints.forEach(function (point) {
        box.count += point.count;
        box.rMin = Math.min(box.rMin, point.r);
        box.rMax = Math.max(box.rMax, point.r);
        box.gMin = Math.min(box.gMin, point.g);
        box.gMax = Math.max(box.gMax, point.g);
        box.bMin = Math.min(box.bMin, point.b);
        box.bMax = Math.max(box.bMax, point.b);
      });

      box.range = Math.max(box.rMax - box.rMin, box.gMax - box.gMin, box.bMax - box.bMin);
      return box;
    }

    boxes = [makeBox(points)];

    while (boxes.length < maxColours) {
      boxes.sort(function (a, b) {
        return (b.range * b.count) - (a.range * a.count);
      });

      var box = boxes.shift();
      if (!box || box.points.length < 2 || box.range === 0) {
        if (box) boxes.push(box);
        break;
      }

      var channel = 'r';
      var rRange = box.rMax - box.rMin;
      var gRange = box.gMax - box.gMin;
      var bRange = box.bMax - box.bMin;
      var running = 0;
      var splitIndex = 0;

      if (gRange >= rRange && gRange >= bRange) channel = 'g';
      if (bRange >= rRange && bRange >= gRange) channel = 'b';

      box.points.sort(function (a, b) {
        return a[channel] - b[channel];
      });

      for (var p = 0; p < box.points.length; p += 1) {
        running += box.points[p].count;
        if (running >= box.count / 2) {
          splitIndex = Math.max(1, p + 1);
          break;
        }
      }

      if (splitIndex <= 0 || splitIndex >= box.points.length) {
        splitIndex = Math.max(1, Math.floor(box.points.length / 2));
      }

      boxes.push(makeBox(box.points.slice(0, splitIndex)));
      boxes.push(makeBox(box.points.slice(splitIndex)));
    }

    boxes.forEach(function (box) {
      var count = 0;
      var r = 0;
      var g = 0;
      var b = 0;

      box.points.forEach(function (point) {
        count += point.count;
        r += point.r * point.count;
        g += point.g * point.count;
        b += point.b * point.count;
      });

      if (count) {
        palette.push({
          r: Math.round(r / count),
          g: Math.round(g / count),
          b: Math.round(b / count)
        });
      }
    });

    if (!palette.length) return;

    for (var j = 0; j < data.length; j += 4) {
      var cacheKey = (data[j] >> 2) + ',' + (data[j + 1] >> 2) + ',' + (data[j + 2] >> 2);
      var colour = cache[cacheKey];

      if (!colour) {
        var best = palette[0];
        var bestDistance = Infinity;

        palette.forEach(function (candidate) {
          var dr = data[j] - candidate.r;
          var dg = data[j + 1] - candidate.g;
          var db = data[j + 2] - candidate.b;
          var distance = (dr * dr) + (dg * dg) + (db * db);

          if (distance < bestDistance) {
            bestDistance = distance;
            best = candidate;
          }
        });

        colour = best;
        cache[cacheKey] = colour;
      }

      data[j] = colour.r;
      data[j + 1] = colour.g;
      data[j + 2] = colour.b;
    }

    ctx.putImageData(imageData, 0, 0);
  }

  function renderPreview() {
    var variant = getSelectedVariant();
    var size = getSizeFromVariant(variant);
    var sourceDimensions = getSourceDimensions();
    var grid = getGrid(size, sourceDimensions);

    renderOptionControls();
    updateSuggestion();
    updateUpgrade();
    updateSubmitState();

    if (!state.image) {
      root.classList.remove('has-image');
    }

    if (!state.image || !grid) {
      els.controls.hidden = true;
      els.editToggle.hidden = true;
      els.changePhoto.hidden = !state.image;
      els.canvasWrap.hidden = true;
      els.empty.hidden = false;
      els.empty.textContent = state.image
        ? 'Choose a painting size to generate the preview.'
        : 'Upload an image to generate the diamond preview.';
      root.classList.remove('is-editing');
      root.classList.toggle('has-image', !!state.image);
      return;
    }

    if (!state.hasChosenSize) {
      els.controls.hidden = true;
      els.editToggle.hidden = true;
      els.changePhoto.hidden = false;
      els.canvasWrap.hidden = true;
      els.empty.hidden = false;
      els.empty.textContent = 'Choose a painting size to generate the preview.';
      root.classList.remove('is-editing');
      root.classList.add('has-image');
      return;
    }

    var sourceCanvas = makeRotatedCanvas(state.image);
    var sourceRatio = sourceCanvas.width / sourceCanvas.height;
    var targetRatio = grid.widthDiamonds / grid.heightDiamonds;
    var cropWidth;
    var cropHeight;

    if (sourceRatio > targetRatio) {
      cropHeight = sourceCanvas.height / state.zoom;
      cropWidth = cropHeight * targetRatio;
    } else {
      cropWidth = sourceCanvas.width / state.zoom;
      cropHeight = cropWidth / targetRatio;
    }

    cropWidth = Math.min(cropWidth, sourceCanvas.width);
    cropHeight = Math.min(cropHeight, sourceCanvas.height);

    var maxPanX = sourceCanvas.width - cropWidth;
    var maxPanY = sourceCanvas.height - cropHeight;
    var sx = (maxPanX / 2) + (state.panX * maxPanX / 2);
    var sy = (maxPanY / 2) + (state.panY * maxPanY / 2);
    var gridCanvas = document.createElement('canvas');
    var gridCtx = gridCanvas.getContext('2d');
    var cellSize = getPreviewCellSize(grid);
    var canvas = els.canvas;
    var ctx = canvas.getContext('2d');

    gridCanvas.width = grid.widthDiamonds;
    gridCanvas.height = grid.heightDiamonds;
    gridCtx.imageSmoothingEnabled = true;
    gridCtx.drawImage(
      sourceCanvas,
      sx,
      sy,
      cropWidth,
      cropHeight,
      0,
      0,
      grid.widthDiamonds,
      grid.heightDiamonds
    );

    limitCanvasColours(gridCanvas, getMaxColoursForSize(size));

    canvas.width = grid.widthDiamonds * cellSize;
    canvas.height = grid.heightDiamonds * cellSize;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    drawSquarePreview(gridCanvas, ctx, cellSize);

    els.editToggle.hidden = false;
    els.editToggle.textContent = state.isEditing ? 'Done Editing' : 'Crop / Adjust Image';
    els.controls.hidden = !state.isEditing;
    els.changePhoto.hidden = false;
    els.canvasWrap.hidden = false;
    els.empty.hidden = true;
    els.empty.textContent = 'Upload an image to generate the diamond preview.';
    root.classList.add('has-image');
    root.classList.toggle('is-editing', state.isEditing);
  }

  function scheduleRender() {
    window.requestAnimationFrame(renderPreview);
  }

  function setPan(x, y) {
    state.panX = Math.max(-1, Math.min(1, x));
    state.panY = Math.max(-1, Math.min(1, y));
    els.panX.value = String(state.panX);
    els.panY.value = String(state.panY);
    renderPreview();
  }

  function clearUploadedImage() {
    if (state.image) state.image.onload = null;
    if (state.imageUrl && state.imageUrl.indexOf('blob:') === 0) URL.revokeObjectURL(state.imageUrl);

    state.image = null;
    state.imageUrl = '';
    state.cartPreviewImageUrl = '';
    state.uploadedFileName = '';
    state.uploadedPhotoUrl = '';
    state.uploadedPhotoKey = '';
    state.uploadedPhotoName = '';
    state.isUploadingPhoto = false;
    state.photoUploadError = '';
    state.photoUploadRequestId += 1;
    state.customKitId = '';
    state.isCartEdit = false;
    state.editCartItemKey = '';
    state.editOriginalPhotoUrl = '';
    state.editRestoreParams = null;
    state.zoom = 1;
    state.panX = 0;
    state.panY = 0;
    state.rotation = 0;
    state.isEditing = false;
    state.isPanning = false;
    state.hasChosenSize = false;
    state.userHasManuallySelectedSize = false;
    state.showAllSizes = false;
    state.selectedVariantId = null;
    state.recommendedSizeKey = '';
    setSuccessState(false);
    els.upload.value = '';
    if (els.kitId) els.kitId.value = '';
    if (els.photoName) els.photoName.value = '';
    if (els.photoUrl) els.photoUrl.value = '';
    if (els.photoKey) els.photoKey.value = '';
    if (els.abCheckbox) els.abCheckbox.checked = false;
    if (els.priorityCheckbox) els.priorityCheckbox.checked = false;
    els.zoom.value = '1';
    els.panX.value = '0';
    els.panY.value = '0';

    var ctx = els.canvas.getContext('2d');
    ctx.clearRect(0, 0, els.canvas.width, els.canvas.height);
    els.canvas.width = 0;
    els.canvas.height = 0;
    els.canvas.classList.remove('is-panning');
    root.classList.remove('has-image', 'is-editing');

    renderPreview();
  }

  function openCartView() {
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cartdrawer:open', { bubbles: true }));

    if (window.Shopify && window.Shopify.theme && window.Shopify.theme.cartDrawer && typeof window.Shopify.theme.cartDrawer.open === 'function') {
      window.Shopify.theme.cartDrawer.open();
      return;
    }

    var drawerElement = document.querySelector('cart-drawer, cart-notification, [data-cart-drawer], .cart-drawer');

    if (drawerElement && typeof drawerElement.open === 'function') {
      drawerElement.open();
      return;
    }

    var cartTrigger = document.querySelector('[data-cart-drawer-toggle], [data-cart-toggle], [aria-controls*="cart"], a[href="/cart"]');

    if (cartTrigger && cartTrigger.tagName !== 'A') {
      cartTrigger.click();
      return;
    }

    window.location.href = '/cart';
  }

  function clickExistingAddToCart() {
    var form = getProductForm();
    var variant = getMatchedSelectedVariant();
    var customKitId;
    var hasAbDiamonds;
    var hasPriorityProcessing;
    var enhancement;
    var properties;
    var items;

    if (state.isAddingToCart || state.isUploadingPhoto || !state.uploadedPhotoUrl || state.photoUploadError || !state.image || !isVariantAvailable(variant)) {
      console.warn('[Diamond Preview] add to cart blocked', {
        isAddingToCart: state.isAddingToCart,
        isUploadingPhoto: state.isUploadingPhoto,
        hasImage: !!state.image,
        uploadedPhotoUrl: state.uploadedPhotoUrl,
        uploadedPhotoKey: state.uploadedPhotoKey,
        photoUploadError: state.photoUploadError,
        selectedDiamondType: variant ? getShapeFromVariant(variant) : null,
        selectedSize: variant && getSizeFromVariant(variant) ? getSizeFromVariant(variant).label : null,
        selectedEnhancement: getSelectedEnhancement(),
        matchedVariant: variant,
        matchedVariantId: variant ? variant.id : null,
        matchedVariantAvailability: variant ? variant.available : null,
        hiddenInputValue: form && form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : null
      });
      return;
    }

    state.isAddingToCart = true;
    if (els.addToCart) {
      els.addToCart.disabled = true;
      els.addToCart.textContent = 'Adding...';
    }

    if (form) {
      form.querySelectorAll('[name="id"]').forEach(function (input) {
        input.value = variant.id;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      ensurePhotoPropertiesAttachedToForm();
    }

    customKitId = ensureCustomKitId();
    if (els.kitId) els.kitId.value = customKitId;
    state.cartPreviewImageUrl = createCartPreviewImageUrl();

    if (state.cartPreviewImageUrl) {
      try {
        window.sessionStorage.setItem(getCartPreviewStorageKey(customKitId), state.cartPreviewImageUrl);
        window.sessionStorage.setItem(getCartPreviewStorageKeyFromUrl(state.uploadedPhotoUrl), state.cartPreviewImageUrl);
      } catch (error) {
        console.warn('[Diamond Preview] Could not store cart preview image for this session', error);
      }
    }

    hasAbDiamonds = isAddOnSelected('ab');
    hasPriorityProcessing = isAddOnSelected('priority');
    enhancement = getSelectedEnhancement();
    properties = {
      'Uploaded Photo URL': state.uploadedPhotoUrl
    };

    items = [{
      id: Number(variant.id),
      quantity: 1,
      properties: properties
    }];

    debugVariantState('final variant submitted to cart', variant);

    console.log('[Diamond Preview] ajax cart items submitted', {
      selectedSize: getSizeFromVariant(variant) ? getSizeFromVariant(variant).label : null,
      selectedDiamondType: getShapeFromVariant(variant),
      customKitId: customKitId,
      abDiamonds: hasAbDiamonds,
      priorityProcessing: hasPriorityProcessing,
      enhancement: enhancement,
      matchedVariant: variant,
      matchedVariantId: variant.id,
      matchedVariantAvailability: variant.available,
      hiddenInputValueBeforeSubmit: form && form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : null,
      items: items
    });

    removeEditedCartLineIfNeeded()
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () {
          return {};
        }).then(function (error) {
          console.error('[Diamond Preview] cart/add.js error response', {
            status: response.status,
            statusText: response.statusText,
            error: error
          });
          throw error;
        });
      }

        return response.text().then(function (text) {
          var cartResponse = {};

          if (text) {
            try {
              cartResponse = JSON.parse(text);
            } catch (error) {
              cartResponse = { rawResponse: text };
              console.warn('[Diamond Preview] cart/add.js response was not JSON, but the request succeeded', error);
            }
          }

          console.log('[Diamond Preview] cart/add.js response', cartResponse);
          return cartResponse;
        });
      })
      .then(function (cartResponse) {
        state.isCartEdit = false;
        state.editCartItemKey = '';
        state.editOriginalPhotoUrl = '';
        state.editRestoreParams = null;
        setSuccessState(true);

        return fetchCartData()
          .then(function (cartData) {
            console.log('[Diamond Preview] cart.js response after add', {
              item_count: cartData && cartData.item_count,
              cart: cartData
            });
            updateCartUi(cartData);
          })
          .catch(function (error) {
            console.warn('[Diamond Preview] Cart UI refresh failed after successful add', error);
          })
          .then(function () {
            return cartResponse;
          });
      })
      .catch(function (error) {
        console.error('[Diamond Preview] Add to cart failed', error);
      })
      .finally(function () {
        state.isAddingToCart = false;
        updateSubmitState();
      });
  }

  function syncSelectedVariantBeforeSubmit(form) {
    var variant = getMatchedSelectedVariant();

    if (!form || !isVariantAvailable(variant)) return;

    form.querySelectorAll('[name="id"]').forEach(function (input) {
      input.value = variant.id;
    });

    ensurePhotoPropertiesAttachedToForm();
    debugVariantState('form submit variant sync', variant);
  }

  function resetEditorForLoadedImage() {
    state.zoom = 1;
    state.panX = 0;
    state.panY = 0;
    state.rotation = 0;
    state.isEditing = false;
    state.hasChosenSize = false;
    state.userHasManuallySelectedSize = false;
    state.showAllSizes = false;
    els.zoom.value = '1';
    els.panX.value = '0';
    els.panY.value = '0';
  }

  function finishLoadedImage(preserveCurrentVariant) {
    var currentVariant = getSelectedVariant();
    var shouldPreserveCurrentVariant = preserveCurrentVariant || state.userHasManuallySelectedSize;

    resetEditorForLoadedImage();

    if (shouldPreserveCurrentVariant && currentVariant && getSizeFromVariant(currentVariant)) {
      state.hasChosenSize = true;
      state.userHasManuallySelectedSize = true;
      applyProgrammaticVariant(currentVariant);
      renderPreview();
      return;
    }

    if (!selectRecommendedDefaultSizeForImage()) {
      renderPreview();
    }
  }

  function getDecodedUrlParam(value) {
    if (!value) return '';

    try {
      return decodeURIComponent(value);
    } catch (error) {
      return value;
    }
  }

  function isTruthyParamValue(value) {
    return /^(1|true|yes|y|on)$/i.test(normalizeText(getDecodedUrlParam(value)));
  }

  function restoreEnhancementSelectionFromEditUrl(params) {
    var abValue = params.get('dp_ab');
    var priorityValue = params.get('dp_priority');
    var enhancementValue = normalizeText(getDecodedUrlParam(params.get('dp_enhancement')));
    var urlVariantId = params.get('variant');
    var urlVariant = urlVariantId
      ? product.variants.find(function (variant) {
        return String(variant.id) === String(urlVariantId);
      })
      : null;
    var enhancement = enhancementValue || getEnhancementFromVariant(urlVariant);
    var hasAbDiamonds = abValue !== null
      ? isTruthyParamValue(abValue)
      : enhancement === ENHANCEMENT_AB || enhancement === ENHANCEMENT_AB_PRIORITY;
    var hasPriorityProcessing = priorityValue !== null
      ? isTruthyParamValue(priorityValue)
      : enhancement === ENHANCEMENT_PRIORITY || enhancement === ENHANCEMENT_AB_PRIORITY;
    var matchedVariant;

    console.log('[Diamond Preview] edit restore params', {
      dpAb: abValue,
      dpPriority: priorityValue,
      dpEnhancement: enhancementValue,
      dpLine: params.get('dp_line') || params.get('dp_key') || params.get('key'),
      dpPhoto: getDecodedUrlParam(params.get('dp_photo'))
    });

    if (els.abCheckbox) {
      els.abCheckbox.checked = hasAbDiamonds;
      els.abCheckbox.dispatchEvent(new Event('input', { bubbles: true }));
      els.abCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (els.priorityCheckbox) {
      els.priorityCheckbox.checked = hasPriorityProcessing;
      els.priorityCheckbox.dispatchEvent(new Event('input', { bubbles: true }));
      els.priorityCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    }

    matchedVariant = getMatchedSelectedVariant();

    console.log('[Diamond Preview] restored enhancements', {
      selectedEnhancement: getSelectedEnhancement(),
      abChecked: !!(els.abCheckbox && els.abCheckbox.checked),
      priorityChecked: !!(els.priorityCheckbox && els.priorityCheckbox.checked),
      matchedVariantId: matchedVariant ? matchedVariant.id : null
    });

    updateSubmitState();
  }

  function syncVariantAfterEnhancementRestore() {
    var matchedVariant = getMatchedSelectedVariant();

    if (!isVariantAvailable(matchedVariant)) return;

    applyProgrammaticVariant(matchedVariant);

    console.log('[Diamond Preview] restored enhancement variant sync', {
      selectedEnhancement: getSelectedEnhancement(),
      abChecked: !!(els.abCheckbox && els.abCheckbox.checked),
      priorityChecked: !!(els.priorityCheckbox && els.priorityCheckbox.checked),
      matchedVariantId: matchedVariant.id
    });
  }

  function restoreUploadedPhotoFromEditUrl() {
    var params = new URLSearchParams(window.location.search);
    var isEdit = params.get('dp_edit');
    var photoUrl = getDecodedUrlParam(params.get('dp_photo'));
    var urlVariantId = params.get('variant');
    var editCartItemKey = getDecodedUrlParam(params.get('dp_line') || params.get('dp_key') || params.get('key'));
    var image;

    if (isEdit !== '1' || !photoUrl) return false;

    if (state.image) state.image.onload = null;
    if (state.imageUrl && state.imageUrl.indexOf('blob:') === 0) URL.revokeObjectURL(state.imageUrl);

    state.photoUploadRequestId += 1;
    state.cartPreviewImageUrl = '';
    state.image = null;
    state.imageUrl = photoUrl;
    state.uploadedFileName = 'Uploaded photo';
    state.uploadedPhotoUrl = photoUrl;
    state.uploadedPhotoKey = '';
    state.uploadedPhotoName = 'Uploaded photo';
    state.isCartEdit = true;
    state.editCartItemKey = editCartItemKey;
    state.editOriginalPhotoUrl = photoUrl;
    state.editRestoreParams = params;
    if (urlVariantId) state.selectedVariantId = String(urlVariantId);
    state.isUploadingPhoto = false;
    state.photoUploadError = '';
    setSuccessState(false);
    ensureCustomKitId();
    restoreEnhancementSelectionFromEditUrl(params);

    if (els.photoName) els.photoName.value = state.uploadedPhotoName;
    if (els.photoUrl) els.photoUrl.value = photoUrl;
    if (els.photoKey) els.photoKey.value = '';

    image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = function () {
      state.image = image;
      finishLoadedImage(!!urlVariantId);
      if (state.editRestoreParams) {
        restoreEnhancementSelectionFromEditUrl(state.editRestoreParams);
        syncVariantAfterEnhancementRestore();
      }
    };
    image.onerror = function () {
      state.image = null;
      state.imageUrl = '';
      clearUploadedPhotoStorage();
      state.photoUploadError = 'We could not reload this uploaded photo. Please upload it again.';
      updateSubmitState();
    };
    image.src = photoUrl;

    return true;
  }

  els.upload.addEventListener('change', function () {
    var file = els.upload.files && els.upload.files[0];
    if (!file) return;

    if (!isAllowedPhotoFile(file)) {
      state.photoUploadRequestId += 1;
      state.isUploadingPhoto = false;
      clearUploadedPhotoStorage();
      state.photoUploadError = 'Please upload a JPG, PNG or WEBP image.';
      updateSubmitState();
      return;
    }

    if (!state.image) {
      state.userHasManuallySelectedSize = false;
      state.hasChosenSize = false;
    }

    if (state.imageUrl && state.imageUrl.indexOf('blob:') === 0) URL.revokeObjectURL(state.imageUrl);

    state.cartPreviewImageUrl = '';
    setSuccessState(false);
    ensureCustomKitId();
    updatePhotoLineItemProperties(file);
    uploadPhotoToWorker(file);

    state.imageUrl = URL.createObjectURL(file);
    state.image = new Image();
    state.image.onload = function () {
      finishLoadedImage(false);
    };
    state.image.src = state.imageUrl;
  });

  els.zoom.addEventListener('input', function () {
    state.zoom = Number(els.zoom.value) || 1;
    renderPreview();
  });

  els.panX.addEventListener('input', function () {
    state.panX = Math.max(-1, Math.min(1, Number(els.panX.value) || 0));
    renderPreview();
  });

  els.panY.addEventListener('input', function () {
    state.panY = Math.max(-1, Math.min(1, Number(els.panY.value) || 0));
    renderPreview();
  });

  els.rotateLeft.addEventListener('click', function () {
    state.rotation = (state.rotation + 270) % 360;
    state.panX = 0;
    state.panY = 0;
    els.panX.value = '0';
    els.panY.value = '0';
    renderPreview();
  });

  els.rotateRight.addEventListener('click', function () {
    state.rotation = (state.rotation + 90) % 360;
    state.panX = 0;
    state.panY = 0;
    els.panX.value = '0';
    els.panY.value = '0';
    renderPreview();
  });

  els.canvas.addEventListener('pointerdown', function (event) {
    if (!state.isEditing || !state.image) return;

    state.isPanning = true;
    state.dragStartX = event.clientX;
    state.dragStartY = event.clientY;
    state.dragStartPanX = state.panX;
    state.dragStartPanY = state.panY;
    els.canvas.classList.add('is-panning');
    els.canvas.setPointerCapture(event.pointerId);
  });

  els.canvas.addEventListener('pointermove', function (event) {
    if (!state.isPanning) return;

    var rect = els.canvas.getBoundingClientRect();
    var dx = (event.clientX - state.dragStartX) / Math.max(1, rect.width);
    var dy = (event.clientY - state.dragStartY) / Math.max(1, rect.height);

    setPan(state.dragStartPanX - (dx * 2), state.dragStartPanY - (dy * 2));
  });

  els.canvas.addEventListener('pointerup', function (event) {
    state.isPanning = false;
    els.canvas.classList.remove('is-panning');

    if (els.canvas.hasPointerCapture(event.pointerId)) {
      els.canvas.releasePointerCapture(event.pointerId);
    }
  });

  els.canvas.addEventListener('pointercancel', function () {
    state.isPanning = false;
    els.canvas.classList.remove('is-panning');
  });

  document.addEventListener('change', function (event) {
    if (event.target === els.upload || root.contains(event.target)) return;
    scheduleRender();
  });

  document.addEventListener('input', function (event) {
    if (event.target === els.zoom || root.contains(event.target)) return;
    scheduleRender();
  });

  [els.abCheckbox, els.priorityCheckbox].forEach(function (checkbox) {
    if (!checkbox) return;

    checkbox.addEventListener('change', function () {
      var form = getProductForm();
      updateSubmitState();
      if (form) {
        form.querySelectorAll('[name="id"]').forEach(function (input) {
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    });
  });

  root.addEventListener('click', function (event) {
    var sizeButton = event.target.closest('[data-dp-size-key]');
    var customSizeButton = event.target.closest('[data-dp-toggle-custom-size]');
    var shapeButton = event.target.closest('[data-dp-shape]');
    var suggestionButton = event.target.closest('[data-dp-apply-suggestion]');
    var upgradeButton = event.target.closest('[data-dp-apply-upgrade]');
    var editButton = event.target.closest('[data-dp-edit-toggle]');
    var changePhotoButton = event.target.closest('[data-dp-change-photo]');
    var removePhotoButton = event.target.closest('[data-dp-remove-photo]');
    var addToCartButton = event.target.closest('[data-dp-add-to-cart]');
    var uploadAnotherButton = event.target.closest('[data-dp-upload-another]');
    var viewCartButton = event.target.closest('[data-dp-view-cart]');
    var currentVariant = getSelectedVariant();
    var currentSizeKey = getSizeKey(getSizeFromVariant(currentVariant));
    var currentShape = getShapeFromVariant(currentVariant);
    var variant = null;

    if (uploadAnotherButton) {
      clearUploadedImage();
      return;
    }

    if (viewCartButton) {
      window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root.replace(/\/?$/, '/') + 'cart'
        : '/cart';
      return;
    }

    if (editButton) {
      state.isEditing = !state.isEditing;
      renderPreview();
      return;
    }

    if (changePhotoButton) {
      els.upload.click();
      return;
    }

    if (removePhotoButton) {
      clearUploadedImage();
      return;
    }

    if (addToCartButton) {
      clickExistingAddToCart();
      return;
    }

    if (customSizeButton) {
      state.showAllSizes = !state.showAllSizes;
      renderPreview();
      return;
    }

    if (sizeButton) {
      variant = findVariantForSize(sizeButton.getAttribute('data-dp-size-key'));
      if (variant) {
        state.hasChosenSize = true;
        if (!state.isProgrammaticSizeChange) state.userHasManuallySelectedSize = true;
        applyVariantToForm(variant);
      }
      return;
    }

    if (shapeButton) {
      if (!state.hasChosenSize) return;
      variant = findVariantForSelection(currentSizeKey, shapeButton.getAttribute('data-dp-shape')) ||
        findAnyVariantForSizeAndShape(currentSizeKey, shapeButton.getAttribute('data-dp-shape'));
      if (variant) applyVariantToForm(variant);
      return;
    }

    if (upgradeButton) {
      var upgrade = findUpgradeVariant();
      if (upgrade) {
        state.hasChosenSize = true;
        state.userHasManuallySelectedSize = true;
        applyVariantToForm(upgrade.variant);
      }
      return;
    }

    if (!suggestionButton || !state.recommendedSizeKey) return;

    variant = findVariantForSize(state.recommendedSizeKey);
    if (!variant) {
      suggestionButton.disabled = true;
      suggestionButton.insertAdjacentHTML(
        'afterend',
        '<span class="dp-preview__suggestion-note">This size is not available for the current product options.</span>'
      );
      return;
    }

    state.hasChosenSize = true;
    state.userHasManuallySelectedSize = true;
    applyVariantToForm(variant);
  });

  document.addEventListener('variant:change', scheduleRender);
  document.addEventListener('product:variant-change', scheduleRender);
  document.addEventListener('cart:updated', fetchAndFormatCartProperties);
  document.addEventListener('cart:refresh', fetchAndFormatCartProperties);

  function watchVariantId() {
    var form = getProductForm();
    var idInput = form ? form.querySelector('[name="id"]') : null;

    if (!idInput) return;

    if (String(idInput.value || '') !== String(state.lastVariantId || '')) {
      state.lastVariantId = idInput.value;
      scheduleRender();
    }
  }

  var form = getProductForm();
  if (form) {
    var idInput = form.querySelector('[name="id"]');

    form.addEventListener('submit', function () {
      syncSelectedVariantBeforeSubmit(form);
    }, true);

    form.addEventListener('formdata', function (event) {
      var variant = getMatchedSelectedVariant();

      if (isVariantAvailable(variant)) {
        event.formData.set('id', variant.id);
        syncPhotoPropertiesToFormData(event.formData);
        debugVariantState('ajax formdata variant sync', variant);
      }
    });

    ensurePhotoPropertiesAttachedToForm();

    if (idInput) {
      state.lastVariantId = idInput.value;

      new MutationObserver(function () {
        if (idInput.value !== state.lastVariantId) {
          state.lastVariantId = idInput.value;
          scheduleRender();
        }
      }).observe(idInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }
  }

  window.setInterval(watchVariantId, 300);
  hideNativeVariantPickers();
  if (!restoreUploadedPhotoFromEditUrl()) {
    renderPreview();
  }
  window.setTimeout(fetchAndFormatCartProperties, 500);
  }

  function initAllDiamondPreviews() {
    document.querySelectorAll('[data-dp-preview]').forEach(initDiamondPreview);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllDiamondPreviews);
  } else {
    initAllDiamondPreviews();
  }
})();
